
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import DialogLayout from '@/components/DialogLayout.vue';
import RushIcon from '@/components/Icons/RushIcon.vue';
import FastTrackIcon from '@/components/Icons/FastTrackIcon.vue';
import {
  Orderline,
  OrderlineDetails,
  RushOption,
  ShippingDeliveryMethod
} from '../store/models/OrderlineModel';
import { OrdersService } from '../services/orders-service';
import { ShippingService } from '@/services/shipping-service';
import { ConversionHelper } from '../helpers/ConversionHelper';
import { AxiosResponse } from 'axios';
import { QuickDialog } from '../store/models/DialogModel';
import ItemService from '@/services/item-service';
import { Item } from '@/store/models/ItemModel';
import { ConstValues, RequestedOrderlineMetricTypes } from '../ConstValues';
import { IsLikeItem } from '@/helpers/OrderlineHelper';
import { StringHelper } from '@/helpers/StringHelper';
import { watch } from 'vue';
import { SetSnackBar } from '@/helpers/SnackbarHelper';
@Component({
  components: { DialogLayout, RushIcon, FastTrackIcon }
})
export default class MaxQuantityPerRoll extends Vue {
  $refs!: {};
  /* Properties */
  @Prop({ required: true })
  orderline!: OrderlineDetails;

  get formattedQuantity() {
    return StringHelper.formatQuantity(this.requestedQuantityPerRoll);
  }
  get maxQuantity() {
    return Math.min(this.orderline.Quantity, this.maxQuantityUntilExceedsDiameter);
  }
  get generatedAmtOfRolls() {
    return Math.ceil(this.orderline.Quantity / this.requestedQuantityPerRoll);
  }
  formatQuantity(value: number) {
    return StringHelper.formatQuantity(value);
  }
  handleQuantityInput(newValue: any) {
    this.requestedQuantityPerRoll = parseInt(newValue.toString().replace(/\D/g, ''));
  }

  nearestMultipleBelowDieAcross() {
    return Math.max(
      this.dieAcross, // this prevents from being 0 rolls
      Math.min(
        this.maxMultipleOfDieAcross,
        Math.floor(this.generatedAmtOfRolls / this.dieAcross) * this.dieAcross
      )
    );
  }
  nearestMultipleAboveDieAcross() {
    return Math.min(
      this.maxMultipleOfDieAcross,
      Math.ceil(this.generatedAmtOfRolls / this.dieAcross) * this.dieAcross
    );
  }

  get maxMultipleOfDieAcross() {
    return Math.floor(this.maxQuantityOfRolls / this.dieAcross) * this.dieAcross;
  }

  /* Data */
  requestedQuantityPerRoll = 0;

  maxQuantityOfRolls = 100;
  maxOrderQuantity = 100000;
  maxQuantityUntilExceedsDiameter = 100000;
  minQuantityPerRoll = 1;

  dieAcross = 7;
  selectedButtonIndex: number | number[] = -1;
  hideButtonForRollsAbove = false;
  isLoading = false;

  rollsBelow = 0;
  rollsAbove = 0;
  /* Methods */
  @Watch('orderline')
  async onOrderlineChanged() {
    await this.Initialize();
    this.CanSubmit();
  }
  @Watch('selectedButtonIndex')
  onSelectedButtonChanged() {
    this.CanSubmit();
  }
  @Watch('requestedQuantityPerRoll')
  onQuantityChanged() {
    this.selectedButtonIndex = 0;
    this.CalculateRollsForButtons();
    this.CanSubmit();
  }

  CalculateRollsForButtons() {
    this.rollsBelow = this.nearestMultipleBelowDieAcross();
    this.rollsAbove = this.nearestMultipleAboveDieAcross();
  }
  get rollsAboveAndBelowAreEqual() {
    return this.rollsBelow == this.rollsAbove;
  }
  CanSubmit() {
    this.hideButtonForRollsAbove =
      this.rollsAboveAndBelowAreEqual ||
      this.rollsAbove * this.requestedQuantityPerRoll > this.maxOrderQuantity ||
      this.rollsAbove > this.maxQuantityOfRolls;
    if (this.hideButtonForRollsAbove) {
      this.selectedButtonIndex = 0;
    }
    const selectedRolls = this.selectedButtonIndex === 0 ? this.rollsBelow : this.rollsAbove;
    this.$emit('can-submit', this.isValid());
    if (selectedRolls !== null) {
      var model = {
        Rolls: selectedRolls,
        Labels: this.requestedQuantityPerRoll
      };
      this.$emit('roll-quantity', model);
    }
  }
  isValid() {
    if (this.selectedButtonIndex == undefined || this.selectedButtonIndex == -1) return false;
    if (this.requestedQuantityPerRoll < this.minQuantityPerRoll) return false;
    if (this.requestedQuantityPerRoll > this.maxQuantity) return false;
    return true;
  }
  async GetMaxLabelQuantity() {
    try {
      let model = {
        OrderlineToEdit: ConversionHelper.convertOrderlineToAddModel(this.orderline),
        RequestedValueToChange: RequestedOrderlineMetricTypes.MaxLabelsPerRoll
      };
      const { data } = await OrdersService.CalculateExpectedRollSpecifications(model);
      this.maxQuantityUntilExceedsDiameter = data.AvailableRollQuantities[0].Item1;
    } catch (err) {
      this.maxQuantityUntilExceedsDiameter = this.orderline.Quantity;
      SetSnackBar(
        'Error has occured, please contact techsupport@just1label.com if you are experiencing any issues'
      );
    }
  }

  async Initialize() {
    this.isLoading = true;
    this.dieAcross = this.orderline.Item.Die.NumberAcross;
    await this.GetMaxLabelQuantity();
    this.requestedQuantityPerRoll = Math.min(
      this.orderline.RequestedMaxLabelQuantity,
      this.maxQuantity
    );
    this.isLoading = false;
  }
  /* Mounted */
  async mounted() {
    await this.Initialize();
  }
  /* Created */
}
